import { selectLayout } from "redux/preferencesSlice";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import TopNavLayout from "./TopNavLayout/TopNavLayout";
import DrawerLayout from "./DrawerLayout/DrawerLayout";
import { handleErrorMessage } from "helpers/methods";
import {
  fetchCampaignRetentionDuration,
  getFirstNameMandatory,
  getManager,
} from "screens/Auth/AuthService";
import { useEffect } from "react";
import {
  addIsManager,
  campaignRetentionDuration,
  changeIsFirstNameMandatory,
} from "redux/generalSlice";

interface CustomProps {
  children: any;
  hideNavs?: boolean;
}

const Layout = (props: CustomProps) => {
  const dispatch = useAppDispatch();
  const layout = useAppSelector(selectLayout);

  useEffect(() => {
    getIsManager();
    getCampaignRetentionDuration();
    getIsFirstNameMandatory();
  }, []);

  const getIsFirstNameMandatory = async () => {
    try {
      const isFirstNameMandatory: boolean = await getFirstNameMandatory();
      dispatch(changeIsFirstNameMandatory(isFirstNameMandatory));
    } catch (error: any) {
      handleErrorMessage(error);
    }
  };

  const getIsManager = async () => {
    try {
      const isManager: boolean = await getManager();
      dispatch(addIsManager(isManager));
    } catch (error: any) {
      handleErrorMessage(error);
    }
  };

  const getCampaignRetentionDuration = async () => {
    try {
      const campaignRetention = await fetchCampaignRetentionDuration();
      dispatch(campaignRetentionDuration(campaignRetention));
    } catch (error: any) {
      console.error(error);
    }
  };

  if (props.hideNavs) {
    return <>{props.children}</>;
  }
  switch (layout) {
    case "horizontal":
      return <TopNavLayout>{props.children}</TopNavLayout>;
    case "vertical":
      return <DrawerLayout>{props.children}</DrawerLayout>;
    default:
      return <DrawerLayout>{props.children}</DrawerLayout>;
  }
};

export default Layout;
